export default function FinancingSection() {
  return (
    <section id="financement" className="py-20 bg-gradient-to-br from-[#0066A1] to-[#004A70]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Financement CEE AGRI-TH-117</h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Bénéficiez d'un financement à 100% grâce aux Certificats d'Économies d'Énergie
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* Eligibility Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mr-4">
                <i className="ri-checkbox-circle-line text-2xl text-[#0066A1]"></i>
              </div>
              <h3 className="text-2xl font-bold text-white">Conditions d'Éligibilité</h3>
            </div>
            <ul className="space-y-4 text-white/90">
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-[#4F8B3A] mr-3 mt-1"></i>
                <span>Exploitation agricole avec serres chauffées</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-[#4F8B3A] mr-3 mt-1"></i>
                <span>Surface minimale de serre : 500 m²</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-[#4F8B3A] mr-3 mt-1"></i>
                <span>Installation par un professionnel RGE</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-[#4F8B3A] mr-3 mt-1"></i>
                <span>Équipement conforme aux exigences CEE</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-[#4F8B3A] mr-3 mt-1"></i>
                <span>Dossier complet et conforme</span>
              </li>
            </ul>
          </div>

          {/* Advantages Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mr-4">
                <i className="ri-gift-line text-2xl text-[#0066A1]"></i>
              </div>
              <h3 className="text-2xl font-bold text-white">Avantages du Financement</h3>
            </div>
            <ul className="space-y-4 text-white/90">
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-[#4F8B3A] mr-3 mt-1"></i>
                <span>Prise en charge à 100% possible</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-[#4F8B3A] mr-3 mt-1"></i>
                <span>Zéro euro d'avance de frais</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-[#4F8B3A] mr-3 mt-1"></i>
                <span>Installation et mise en service incluses</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-[#4F8B3A] mr-3 mt-1"></i>
                <span>Accompagnement administratif complet</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-xl text-[#4F8B3A] mr-3 mt-1"></i>
                <span>Économies immédiates sur vos factures</span>
              </li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
          <h3 className="text-2xl font-bold text-white mb-4">
            Vérifiez Votre Éligibilité Gratuitement
          </h3>
          <p className="text-white/90 mb-6">
            Nos experts analysent votre situation et vous accompagnent dans toutes les démarches
          </p>
          <a 
            href="#contact"
            className="inline-block bg-white hover:bg-gray-100 text-[#0066A1] text-lg font-semibold px-12 py-4 rounded-lg transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Demander une étude d'éligibilité
          </a>
        </div>
      </div>
    </section>
  );
}
